module.exports = __webpack_public_path__ + "static/media/vent-direccio-0.e0433e11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent-direccio-0.svg
// module id = 199
// module chunks = 0